export default __webpack_public_path__ + "static/media/WordGames_06.ceca2df8.png";